import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";
import { useCallback } from "react";

const utils = createTrackingUtils({
  name: "flights_web_fd_fare_rules_source",
  stages: {
    main: 1,
    desktop: 2,
    mobile: 3,
    direct: 4,
    meta: 5,
    checkout_branded_fare: 6,
    checkout_ticket_type: 7
  },
  defaultStage: 1,
  goals: {
    change_included: 1,
    change_sellable: 2,
    cancel_included: 3,
    cancel_sellable: 4,
    no_fare_rules: 5
  }
});

export const useTrackFareRulesSource = () => {
  const { isDesktop, isMobile, isDirect, isMeta } = useProfiler();

  return useCallback(() => {
    if (isDesktop()) utils.stages.desktop();
    if (isMobile()) utils.stages.mobile();
    if (isDirect()) utils.stages.direct();
    if (isMeta()) utils.stages.meta();

    return !!utils.trackWithDefaultStage();
  }, [isDesktop, isDirect, isMeta, isMobile]);
};

export default utils;
